import { Button, Grid, TextField } from "@mui/material";
import dayjs from "dayjs";
import { useState, useEffect, useRef } from "react";
import "dayjs/locale/es";
import Autocomplete from '@mui/material/Autocomplete';
import esArray from "src/general_components/functionEsArray";
import SearchIcon from '@mui/icons-material/Search';
import RestartAltIcon from '@mui/icons-material/RestartAlt';

// Establecer español como idioma predeterminado
dayjs.locale("es");

const BuscadorGeneralMovimientos = (data) => {
  const { setSearchQuery,
    setBuscadorEjecutado,
    clienteSeleccionado,
    setClienteSeleccionado,
    setOptions,
    options,
    setActualizarListado } = data;

  const [estadoPeticion, setEstadoPeticion] = useState(localStorage.getItem('estadoPeticionModelos') === 'true');
  const intervalRef = useRef(null); // 🗂️ Referencia para el intervalo


  // Estados para Fecha
  const [fechaDesdeConcat, setFechaDesdeConcat] = useState("");
  const [fechaHastaConcat, setFechaHastaConcat] = useState("");



  useEffect(() => {
    if (estadoPeticion) return; // 🚩 Detiene el efecto si ya está en true

    intervalRef.current = setInterval(() => {
      const estadoActual = localStorage.getItem('estadoPeticionModelos') === 'true';


      if (estadoActual) {
        setEstadoPeticion(true);
        clearInterval(intervalRef.current); // ✅ Detiene el intervalo
      }
    }, 1000); // Verifica cada segundo

    return () => clearInterval(intervalRef.current); // Limpia si el componente se desmonta
  }, [estadoPeticion]);



  useEffect(() => {
    const hoy = dayjs();
    const primerDiaDelMes = hoy.startOf("month").format("YYYY-MM-DD");
    const fechaActual = hoy.format("YYYY-MM-DD");

    setFechaDesdeConcat(primerDiaDelMes);
    setFechaHastaConcat(fechaActual);
  }, []);

  const handleSearch = () => {
    setSearchQuery({
      input_fecha_desde: fechaDesdeConcat,
      input_fecha_hasta: fechaHastaConcat,
    });
    setBuscadorEjecutado(true);
    setActualizarListado(true);
  };

  const handleClear = () => {
    setSearchQuery("");
    setClienteSeleccionado(null);
    setBuscadorEjecutado(false);
    setOptions({
      ...options,
      sinFilas: true,
      idElementData: false
    });

    setActualizarListado(false);
  };


  // const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [clientesList, setClientesList] = useState([]);

  const handleClienteSeleccionado = (cliente) => {

    setClienteSeleccionado(cliente);
  };
  console.log("clienteSeleccionado", clienteSeleccionado);
  useEffect(() => {
    const getClientes = async () => {
      var clientes = [];
      let cuentas = esArray(JSON.parse(localStorage.getItem("siam-service-getCuentasGenericas"))?.cuentas);
      let condicionIn = false

      //clientes = await getCuentasJuridicas(cuentas,condicionIn);

      let clients = esArray(JSON.parse(localStorage.getItem("siam-cuentas_personas_juridicas"))?.cuentas_personas_juridicas);
      clientes = clients.filter((cliente) =>
        cuentas.find(
          (cuenta) => {
            if (condicionIn === true) {
              return cuenta.id_cuentas === cliente.id_cuentas

            } else {
              return cuenta.id_cuentas !== cliente.id_cuentas
            }
          }
        )
      );

      const user_cuentas = JSON.parse(
        localStorage.getItem("siam-user-cuentas")
      );
      let userCuentasStorage = esArray(user_cuentas);

      if (userCuentasStorage.length < 2) {
        let usersCuentasModificado = [
          { usuarios_cuentas: userCuentasStorage[0] },
        ];
        userCuentasStorage = usersCuentasModificado;
      }
      if (user_cuentas.length > 0) {

        let clientesFilter = clientes.filter((cliente) =>
          userCuentasStorage.find(
            (obj) => obj.usuarios_cuentas.id_cuentas === cliente.id_cuentas
          )
        );
        console.log("clienteSeleccionado", clienteSeleccionado);
        if (clientesFilter && clienteSeleccionado) {

          let objClienteSelected = clientesFilter.filter(cliente => cliente.id_cuentas === clienteSeleccionado)
          setClienteSeleccionado(objClienteSelected[0]);
        }
        setClientesList(esArray(clientesFilter));

      } else {
        if (clienteSeleccionado) {

          let objClienteSelected = clientes.filter(cliente => cliente.id_cuentas === clienteSeleccionado)
          setClienteSeleccionado(objClienteSelected[0]);
        }
        setClientesList(esArray(clientes));

      }
    }
    getClientes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estadoPeticion]);


  const user_cuentas = JSON.parse(
    localStorage.getItem("siam-user-cuentas")
  );

  return (
    <div>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        spacing={2}
      >

        {esArray(user_cuentas).length !== 1 && (
          <Grid item xs={4} sm={6} md={6} style={{ marginTop: "4vh" }}>
            <AutoCompleteClientes
              clientes={clientesList}
              onClienteSeleccionado={handleClienteSeleccionado}
              clienteSeleccionado={clienteSeleccionado}
            />
          </Grid>
        )}

        <Grid item xs={6} sm={4} md={6} style={{ marginTop: "4vh" }}>
          <TextField
            fullWidth
            type="date"
            label="Fecha Desde"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            value={fechaDesdeConcat}
            onChange={(e) => setFechaDesdeConcat(e.target.value)}
          />
        </Grid>
        <Grid item xs={6} sm={4} md={6} style={{ marginTop: "4vh" }}>
          <TextField
            fullWidth
            type="date"
            label="Fecha Hasta"
            variant="outlined"
            InputLabelProps={{ shrink: true }}
            value={fechaHastaConcat}
            onChange={(e) => setFechaHastaConcat(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} sm={4} md={8}>
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={6} sm={4} md={6}>
              <Button
                startIcon={<SearchIcon />}
                variant="contained"
                color="primary"
                onClick={handleSearch}
                sx={{ width: '40vh' }}
              >
                Buscar
              </Button>
            </Grid>
            <Grid item xs={6} sm={4} md={6}>
              <Button variant="outlined" color="secondary" startIcon={<RestartAltIcon />} sx={{ width: '40vh' }} onClick={handleClear}>
                Limpiar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
export default BuscadorGeneralMovimientos;

const AutoCompleteClientes = ({ clientes, onClienteSeleccionado, clienteSeleccionado }) => {
  return (
    <Autocomplete
      options={clientes || []}
      onChange={(event, value) => onClienteSeleccionado(value)}
      fullWidth
      getOptionLabel={(option) => option.id_cuentas + ' - ' + option.razon_social || ""}
      value={clienteSeleccionado}
      renderInput={(params) => (
        <TextField {...params}
          label="Cliente"
        />
      )}
    />
  );
};


